var ProductOptionCategoryType = {
  PRODUCT_OPTION_CATEGORY_TYPE_LANGUAGE:    'language',
  PRODUCT_OPTION_CATEGORY_TYPE_TRANSLATION: 'translation',
  PRODUCT_OPTION_CATEGORY_TYPE_DELIVERY:    'delivery',
  PRODUCT_OPTION_CATEGORY_TYPE_OTHER:       'other',
  PRODUCT_OPTION_CATEGORY_TYPE_ADDITIONAL:  'additional'
}
export default ProductOptionCategoryType
